import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=3d6f01fe&"
import script from "./Company.vue?vue&type=script&setup=true&lang=js&"
export * from "./Company.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports